export default "__VITE_ASSET__b49d406c__"